export const MQ_CHANGE_EVENT = 'kl-mq-change';
export const IN_VP_EVENT = 'kl-in-vp';
export const OUT_VP_EVENT = 'kl-out-vp';
